"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("../ColoradoAcademyVeterinary.module.css"));
function Footer(props) {
    var right = props.right, startPage = props.startPage, endPage = props.endPage;
    var title = right.title, address = right.address, office = right.office, fax = right.fax, email = right.email;
    return (React.createElement("div", { className: styles.footerWrap },
        React.createElement("div", { className: styles.footerLeft },
            React.createElement("p", null,
                React.createElement("strong", null, title)),
            React.createElement("p", null,
                React.createElement("strong", null, "Addres"),
                ": ",
                address),
            React.createElement("p", null,
                React.createElement("strong", null, "Office"),
                ": ",
                office),
            React.createElement("p", null,
                React.createElement("strong", null, "Fax"),
                ": ",
                fax),
            React.createElement("p", null,
                React.createElement("strong", null, "Email"),
                ": ",
                React.createElement("a", { href: "mailto:" + email }, email))),
        React.createElement("div", { className: styles.footerRight },
            React.createElement("span", { className: styles.footerDescription }),
            " Page",
            React.createElement("span", { className: styles.footerBold }, startPage),
            " of",
            React.createElement("span", { className: styles.footerBold }, endPage))));
}
exports.Footer = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvQ29sb3JhZG9BY2FkZW15VmV0ZXJpbmFyeS9jb21tb24tY29tcG9uZW50cy9Gb290ZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUM5Qiw4RUFBaUU7QUFFakUsU0FBZ0IsTUFBTSxDQUFDLEtBQUs7SUFDakIsSUFBQSxtQkFBSyxFQUFFLDJCQUFTLEVBQUUsdUJBQU8sQ0FBUztJQUNsQyxJQUFBLG1CQUFLLEVBQUUsdUJBQU8sRUFBRSxxQkFBTSxFQUFFLGVBQUcsRUFBRSxtQkFBSyxDQUFTO0lBQ2xELE9BQU8sQ0FDSCw2QkFBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLFVBQVU7UUFDN0IsNkJBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxVQUFVO1lBQzdCO2dCQUNJLG9DQUFTLEtBQUssQ0FBVSxDQUN4QjtZQUNKO2dCQUNJLDZDQUF1Qjs7Z0JBQUcsT0FBTyxDQUNqQztZQUNKO2dCQUNJLDZDQUF1Qjs7Z0JBQUcsTUFBTSxDQUNoQztZQUNKO2dCQUNJLDBDQUFvQjs7Z0JBQUcsR0FBRyxDQUMxQjtZQUNKO2dCQUNJLDRDQUFzQjs7Z0JBQUUsMkJBQUcsSUFBSSxFQUFFLFlBQVUsS0FBTyxJQUFHLEtBQUssQ0FBSyxDQUMvRCxDQUNGO1FBQ04sNkJBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxXQUFXO1lBQzlCLDhCQUFNLFNBQVMsRUFBRSxNQUFNLENBQUMsaUJBQWlCLEdBQVM7O1lBQ2xELDhCQUFNLFNBQVMsRUFBRSxNQUFNLENBQUMsVUFBVSxJQUFHLFNBQVMsQ0FBUTs7WUFDdEQsOEJBQU0sU0FBUyxFQUFFLE1BQU0sQ0FBQyxVQUFVLElBQUcsT0FBTyxDQUFRLENBQ2xELENBQ0osQ0FDVCxDQUFBO0FBQ0wsQ0FBQztBQTdCRCx3QkE2QkMifQ==